<template>
  <base-card :id="id" tabled>
    <template v-slot:header>
      <base-card-heading>{{ heading() }}</base-card-heading>
      <div>
        <base-button class="mr-1" small @click="remove">Remove</base-button>
        <base-button secondary small @click="add">Add Drawdown</base-button>
      </div>
    </template>
    <div class="p-4">
      <div class="row">
        <div class="col-sm-6">
          <base-field addon-left-icon="pound-sign" label="Amount">
            <base-input v-model="loan.amount" numeric placeholder="amount" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-right-icon="percent" label="Monthly Interest">
            <base-input v-model="loan.interest" numeric placeholder="interest" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Interest Compounded">
            <base-select v-model="loan.interestCompounded" placeholder="interest compounded" truthy />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Interest Serviced">
            <base-select v-model="loan.interestServiced" placeholder="interest serviced" truthy />
          </base-field>
        </div>
      </div>
    </div>
    <facility-drawdown v-model="loan" :end-date.sync="endDate" :start-date.sync="startDate" />
  </base-card>
</template>

<script>
import { mapGetters } from 'vuex'

import FacilityDrawdown from './FacilityDrawdown.vue'

export default {
  name: 'FacilityLoan',

  components: {
    FacilityDrawdown
  },

  props: {
    endDate: [Date, null],
    index: String,
    maxAmount: [Number, String, null],
    startDate: [Date, null],
    value: Object
  },

  data: () => ({
    id: null,
    loan: {}
  }),

  created () {
    this.id = `facilityLoan${this.$id.gen()}`
    this.assign()
  },

  computed: {
    ...mapGetters({
      schema: 'core/facility-drawdowns/schema'
    })
  },

  methods: {
    add (loan) {
      const drawdown = this.$_.cloneDeep(this.schema)

      this.loan.drawdowns.push(drawdown)
    },

    assign () {
      this.loan = this.$_.cloneDeep(this.value)

      if (this.loan.drawdowns.length === 0) {
        this.add()
      }

      if (!this.$_.has(this.loan, '_id')) {
        this.$emit('added', this.id)
      }
    },

    heading () {
      const number = this.$_.toNumber(this.index) + 1
      const ordinal = this.$formatting.toWordsOrdinal(number)
      const formatted = this.$_.upperFirst(ordinal)

      return `${formatted} Loan`
    },

    remove () {
      this.$emit('remove', this.index)
    }
  },

  watch: {
    loan: {
      deep: true,
      handler () {
        this.$emit('input', this.loan)
      }
    }
  }
}
</script>
